import React, { useState, useEffect } from "react";
import { BASE_URL } from "../utils/config";
import { getAuthHeaders } from "../utils/auth";
import "../styles/BlogsManagement.css";

const BlogsManagement = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const res = await fetch(`${BASE_URL}/blogs`);
      if (res.ok) {
        const data = await res.json();
        setBlogs(Array.isArray(data) ? data : []);
      } else {
        setError("Failed to fetch blogs");
      }
    } catch (error) {
      setError("Error loading blogs");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (blogId) => {
    try {
      const res = await fetch(`${BASE_URL}/blogs/${blogId}`, {
        method: "DELETE",
        headers: getAuthHeaders(false),
      });

      if (res.ok) {
        setBlogs(blogs.filter((blog) => blog._id !== blogId));
        setDeleteConfirm(null);
      } else {
        alert("Failed to delete blog");
      }
    } catch (error) {
      alert("Error deleting blog");
    }
  };

  const toggleFeatured = async (blog) => {
    try {
      const res = await fetch(`${BASE_URL}/blogs/${blog._id}`, {
        method: "PUT",
        headers: getAuthHeaders(),
        body: JSON.stringify({ featured: !blog.featured }),
      });

      if (res.ok) {
        fetchBlogs();
      } else {
        alert("Failed to update blog");
      }
    } catch (error) {
      alert("Error updating blog");
    }
  };

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="admin-loader"></div>
        <p>Loading blogs...</p>
      </div>
    );
  }

  return (
    <div className="blogs-management">
      <div className="blogs-header">
        <button
          className="add-blog-btn"
          onClick={() => (window.location.href = "/admin/blogs/add")}
        >
          <i className="ri-add-line"></i> Add New Blog
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {blogs.length === 0 ? (
        <div className="empty-state">
          <i className="ri-article-line"></i>
          <h3>No Blogs Found</h3>
          <p>Start by adding your first blog post!</p>
          <button
            className="primary-btn"
            onClick={() => (window.location.href = "/admin/blogs/add")}
          >
            Add Blog
          </button>
        </div>
      ) : (
        <div className="blogs-grid">
          {blogs.map((blog) => (
            <div key={blog._id} className="blog-card">
              <div className="blog-image">
                <img src={blog.photo} alt={blog.title} />
                {blog.featured && <span className="featured-badge">Featured</span>}
              </div>
              <div className="blog-content">
                <h4>{blog.title}</h4>
                <p className="blog-author">
                  <i className="ri-user-line"></i> {blog.author}
                </p>
                <p className="blog-preview">
                  {blog.content.length > 150
                    ? blog.content.substring(0, 150) + "..."
                    : blog.content}
                </p>
                <div className="blog-meta">
                  <span>
                    <i className="ri-message-3-line"></i> {blog.comments?.length || 0} comments
                  </span>
                  <span>
                    <i className="ri-calendar-line"></i>{" "}
                    {new Date(blog.createdAt).toLocaleDateString()}
                  </span>
                </div>
                <div className="blog-actions">
                  <button
                    className={`featured-toggle ${blog.featured ? "active" : ""}`}
                    onClick={() => toggleFeatured(blog)}
                    title={blog.featured ? "Remove from featured" : "Mark as featured"}
                  >
                    {blog.featured ? (
                      <i className="ri-star-fill"></i>
                    ) : (
                      <i className="ri-star-line"></i>
                    )}
                  </button>
                  <button
                    className="edit-btn"
                    onClick={() =>
                      (window.location.href = `/admin/blogs/edit/${blog._id}`)
                    }
                  >
                    <i className="ri-edit-line"></i> Edit
                  </button>
                  <button
                    className="delete-btn"
                    onClick={() => setDeleteConfirm(blog._id)}
                  >
                    <i className="ri-delete-bin-line"></i> Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {deleteConfirm && (
        <div className="delete-modal">
          <div className="delete-modal-content">
            <h3>Confirm Delete</h3>
            <p>Are you sure you want to delete this blog? This action cannot be undone.</p>
            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setDeleteConfirm(null)}
              >
                Cancel
              </button>
              <button
                className="confirm-delete-btn"
                onClick={() => handleDelete(deleteConfirm)}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BlogsManagement;

